import { UnresolvedVisitModal } from './components/UnresolvedVisitModal'
import { AreYouStillThereModal } from './AreYouStillThereModal'
import { FinishLaterModal } from './FinishLaterModal'
import { ConfirmVisitCompletionModal } from './ConfirmVisitCompletionModal'
import { ConfirmDeferModal } from './ConfirmDeferModal'
import { AuthorizeOrderReminderModal } from './AuthorizeOrderReminderModal'
import { InPersonRequiredNoticeModal } from './InPersonRequiredNoticeModal'
import { useDailyVisit } from '../../daily/hooks/useDailyVisit'
import { ProductOrderPopUp } from 'components/product-order-popup/ProductOrderPopUp'
import { getTabId } from 'utils/common'

type Props = {
  patientId: string | undefined
  visitId: string | undefined
  patient: any
  visitDetails: any

  isUnresolvedOpen: boolean
  onDismissUnresolved: () => void
  onSubmitUnresolved: (data: { reason: string; otherText?: string }) => Promise<void>

  isClosePopupOpen: boolean
  onDismissClosePopup: () => void
  onConfirmClose: () => void

  showCompleteConfirmation: boolean
  onCompleteConfirmationClose: () => void
  onHandleComplete: () => Promise<void>

  showDeferConfirmation: boolean
  onDeferConfirmationClose: () => void
  onHandleDefer: () => void

  showAuthorizeOrderReminder: any
  onAuthorizeOrderClose: () => void

  isStillThereOpen: boolean
  onStillThereDefer: () => void
  onStillThereContinue: () => void
  stillThereTimeoutMinutes: number

  getOrders: () => void
}

export const VisitPopUpModals = ({
  patientId,
  visitId,
  patient,
  visitDetails,
  isUnresolvedOpen,
  onDismissUnresolved,
  onSubmitUnresolved,
  isClosePopupOpen,
  onDismissClosePopup,
  onConfirmClose,
  showCompleteConfirmation,
  onCompleteConfirmationClose,
  onHandleComplete,
  showDeferConfirmation,
  onDeferConfirmationClose,
  onHandleDefer,
  showAuthorizeOrderReminder,
  onAuthorizeOrderClose,
  isStillThereOpen,
  onStillThereDefer,
  onStillThereContinue,
  stillThereTimeoutMinutes,
  getOrders,
}: Props) => {
  // Hosted here, not beside its state in DailyVisitProvider: both are dialogs portalled to
  // <body> at z-modal, so whichever portal is appended last wins. Opened from the dashboard the
  // notice lands under the visit pop-up; opened from inside it, it lands on top.
  const { isInPersonNoticeOpen, confirmInPersonNotice, patientWithVisitInfo } = useDailyVisit()

  return (
    <>
      <InPersonRequiredNoticeModal
        isOpen={isInPersonNoticeOpen}
        firstName={patientWithVisitInfo?.FirstName ?? ''}
        onConfirm={confirmInPersonNotice}
      />
      {patientId ?
        <ProductOrderPopUp
          patientId={patientId}
          visitId={visitId ?? ''}
          address={patient?.Address}
          pharmacy={patient?.Pharmacy}
          isRefillAllowed={visitDetails?.IsRefillAllowed}
          tabId={getTabId() || ''}
          getOrders={getOrders}
        />
      : null}

      <UnresolvedVisitModal isOpen={isUnresolvedOpen} onClose={onDismissUnresolved} onSubmit={onSubmitUnresolved} />
      <FinishLaterModal isOpen={isClosePopupOpen} onClose={onDismissClosePopup} onConfirmClose={onConfirmClose} />
      <ConfirmVisitCompletionModal
        isOpen={showCompleteConfirmation}
        onClose={onCompleteConfirmationClose}
        onComplete={onHandleComplete}
      />
      <ConfirmDeferModal isOpen={showDeferConfirmation} onClose={onDeferConfirmationClose} onConfirm={onHandleDefer} />
      <AuthorizeOrderReminderModal
        isOpen={!!showAuthorizeOrderReminder}
        encounterUrl={showAuthorizeOrderReminder?.EncounterUrl ?? ''}
        onClose={onAuthorizeOrderClose}
      />
      <AreYouStillThereModal
        isOpen={isStillThereOpen}
        onDefer={onStillThereDefer}
        onContinue={onStillThereContinue}
        timeoutMinutes={stillThereTimeoutMinutes}
      />
    </>
  )
}
